<div class="tw-w-full tw-bg-gray-75 tw-pt-3 tw-rounded-t-6 tw-relative">
  <div class="tw-w-full tw-px-4 tw-pb-10 tw-pt-5 sm:tw-pt-8 tw-overflow-y-auto">
    <ng-container *ngIf="!rehaulView">
      <div class="sm:tw-mb-3 tw-font-body tw-text-center">
        <h1 class="tw-text-700 tw-font-bold" i18n="@@gotQuestions">Got questions?</h1>
        <p class="tw-text-700 tw-font-normal tw-leading-5 tw-mb-4 sm:tw-mb-6" i18n="@@noWorries">No worries!</p>
        <p *ngIf="regimenClass === appConfig.Shared.Regimen.Class.FACE" class="tw-font-body tw-leading-5 tw-text-300 tw-text-gray-500" i18n="@@arrangeOnlineConsultation">
          We will arrange an online consultation <br/> with our skin doctor for you.
        </p>
        <p *ngIf="regimenClass === appConfig.Shared.Regimen.Class.HAIR" class="tw-font-body tw-leading-5 tw-text-300 tw-text-gray-500" i18n="@@arrangeOnlineConsultationHair">
          We will arrange an online consultation <br/> with our hair doctor for you.
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="rehaulView">
      <div class="tw-font-body tw-text-center">
        <h1 class="tw-text-700 tw-font-bold tw-leading-7 tw-mt-2 tw-mb-4 sm:tw-mb-5" i18n="@@gotQuestionsBeforeTreatment">Got questions before <br/> starting treatment?</h1>
        <p *ngIf="regimenClass === appConfig.Shared.Regimen.Class.FACE" class="tw-font-body tw-leading-5 tw-text-300 tw-text-gray-500 tw-mb-0 sm:tw-mb-3" i18n="@@noWorriedBookCall">
          No worries! Book a call with our skin doctor to <br/> clear all your doubts!
        </p>
        <p *ngIf="regimenClass === appConfig.Shared.Regimen.Class.HAIR" class="tw-font-body tw-leading-5 tw-text-300 tw-text-gray-500 tw-mb-0 sm:tw-mb-3" i18n="@@noWorriedBookCallHair">
          No worries! Book a call with our hair doctor to <br/> clear all your doubts!
        </p>
      </div>
    </ng-container>
    <img src="https://cdn.cureskin.com/app/img/doctors_coloured.png"  alt="Doctors"/>
    <div class="tw-w-full tw-flex tw-flex-col tw-font-body tw-mb-6" [ngClass]="(deviceHeight <= minDeviceHeight ? 'tw-max-h-[135px] tw-overflow-y-scroll' : '')">
      <div class="tw-w-full tw-flex tw-gap-2 tw-border tw-border-gray-100 tw-rounded-lg tw-px-2 tw-py-3">
        <img class="tw-w-11" src="https://cdn.cureskin.com/app/img/time.svg" />
        <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-gap-1">
          <p class="tw-text-200 tw-font-medium tw-text-gray-400 tw-leading-none" *ngIf="regimenClass === appConfig.Shared.Regimen.Class.FACE" i18n="@@ourSkinDoctorWillCall">Our skin doctor will call you</p>
          <p class="tw-text-200 tw-font-medium tw-text-gray-400 tw-leading-none" *ngIf="regimenClass === appConfig.Shared.Regimen.Class.HAIR" i18n="@@ourSkinDoctorWillCallHair">Our hair doctor will call you</p>
          <h2 *ngIf="showWorkingHours" i18n="@@ourSkinDoctorWillCallWorkingHours" class="tw-text-300 tw-font-bold tw-leading-none">
            in {{ hours }}&nbsp;{{ hourLabel }}
          </h2>
          <h2 *ngIf="showTomorrowMorning" i18n="@@ourSkinDoctorWillCallTomorrowMorning" class="tw-text-300 tw-font-bold tw-leading-none">
            tomorrow morning
          </h2>
          <h2 *ngIf="showAfterNineAm" i18n="@@ourSkinDoctorWillCallAfter9am" class="tw-text-300 tw-font-bold tw-leading-none">
            after 9 am
          </h2>
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-gap-2 tw-border tw-border-gray-100 tw-rounded-lg tw-px-2 tw-py-3">
        <img class="tw-w-11" src="https://cdn.cureskin.com/app/img/call_white.svg" />
        <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-gap-1">
          <p class="tw-text-200 tw-font-medium tw-text-gray-400 tw-leading-none" i18n="@@youWillGetCallOn">You will get a call on</p>
          <h2 *ngIf="!internalUser" class="tw-text-300 tw-font-bold tw-leading-none">+91 {{ userNumber }}</h2>
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-gap-2 tw-border tw-border-gray-100 tw-rounded-lg tw-px-2 tw-py-3">
        <img class="tw-w-12" src="https://cdn.cureskin.com/app/img/medecine.svg" />
        <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-gap-1">
          <p class="tw-text-200 tw-font-medium tw-text-gray-400 tw-leading-none" i18n="@@askAnyQueriesOrDoubts">You can ask any query and doubts</p>
          <h2 class="tw-text-300 tw-font-bold tw-leading-none" i18n="@@relatedtoTreatment">related to your treatment</h2>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!rehaulView">
      <div class="tw-mb-3 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3 tw-fixed tw-left-4 tw-right-4 tw-bottom-0 sm:tw-bottom-5 tw-bg-white">
      <span
        class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300
        tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden"
        i18n="@@clickToSchedule"
        (click)="requestCall()">
        Click here to schedule your call
      </span>
        <span class="tw-text-300 tw-text-teal-600 tw-p-2 tw-font-bold" i18n="@@cancel" (click)="closePopup()">Cancel</span>
      </div>
    </ng-container>
    <ng-container *ngIf="rehaulView">
      <div class="tw-mb-3 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3 tw-fixed tw-left-4 tw-right-4 tw-bottom-0 sm:tw-bottom-5 tw-bg-white">
      <span
        class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300
        tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden"
        i18n="@@scheduleDoctorCall"
        (click)="requestCall()">
        Schedule call with doctor
      </span>
        <span class="tw-text-300 tw-text-teal-600 tw-p-2 tw-font-bold" i18n="@@dontWantDoctorCall" (click)="closeAndNavigateToHome()">
          No, I don’t want a call
        </span>
      </div>
    </ng-container>
  </div>
    <div
      class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-3 tw-right-3 close-sheet"
      style="width: 35px; height: 35px"
    >
      <div class="tw-text-gray-500 tw-text-500 tw-font-bold" (click)="closeAndNavigateToHome()">&#10005;</div>
    </div>
</div>
